import { create } from "zustand"

import type {
  GetTestTemplateListQuery,
  SortingOrder,
  TestTemplate,
  TestTemplateSortField,
} from "@/graphql/codegen/graphql"
import { GetTestTemplateListDocument } from "@/graphql/codegen/graphql"
import type { SearchFilters } from "@/stores/createSearchStore"
import { createSearchStore } from "@/stores/createSearchStore"

export type TestTemplateSearchFilters = SearchFilters & {
  field?: TestTemplateSortField
  order?: SortingOrder
}

const deduplicateTestTemplates = (newData: TestTemplate[], existingData: TestTemplate[]): TestTemplate[] => {
  const uniqueIds = new Set(existingData.map((template) => template.testTemplateId))
  return [...existingData, ...newData.filter((template) => !uniqueIds.has(template.testTemplateId))]
}

export const useTestTemplatesSearchStore = create(
  createSearchStore<TestTemplate, TestTemplateSearchFilters, GetTestTemplateListQuery>({
    documentNode: GetTestTemplateListDocument,
    deduplicateData: deduplicateTestTemplates,
    getQueryInput: (filters: TestTemplateSearchFilters, offset: number, limit: number) => {
      const { field, order, ...otherFilters } = filters
      return {
        filter: otherFilters,
        offset,
        limit,
        sort: { field, order },
      }
    },
    getQueryVariables: (queryInput) => ({ input: queryInput }),
    extractDataFromResponse: (data) => ({
      __typename: data.testTemplate.list.__typename,
      data:
        data.testTemplate.list.__typename === "TestTemplateListOutputSuccess"
          ? (data.testTemplate.list.testTemplates as TestTemplate[])
          : [],
      error:
        data.testTemplate.list.__typename === "TestTemplateListOutputFailure"
          ? data.testTemplate.list.error
          : undefined,
    }),
  })
)
